// extracted by mini-css-extract-plugin
export default {"dialog-position__locations":"dialog-position__locations--yIobU","dialogPositionLocations":"dialog-position__locations--yIobU"};